import { matchPath, useLocation } from 'react-router-dom';

export const useMatchCurrentPage = (pages: string | string[]) => {
  const { pathname } = useLocation();

  if (typeof pages === 'string') {
    return !!matchPath(pages, pathname);
  }

  return pages.some((page) => !!matchPath(page, pathname));
};
